"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var ButtomComponent_1 = __importDefault(require("../../components/Form/ButtomComponent"));
var NotFound_styled_1 = require("./NotFound.styled");
var context_1 = require("../../context");
var constants_1 = require("../../constants");
var system_1 = require("@mui/system");
var NotFound = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var tokens = (0, context_1.useAuth)().tokens;
    var redirectToHome = function () {
        if (tokens) {
            navigate(constants_1.DASHBOARD_PATH);
        }
        else {
            navigate('/');
        }
    };
    return ((0, jsx_runtime_1.jsx)(NotFound_styled_1.Wrapper, { children: (0, jsx_runtime_1.jsxs)(system_1.Box, __assign({ display: "grid", gap: "20px" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h1", align: "center", color: "secondary", fontWeight: "bold" }, { children: "404" })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h4" }, { children: "P\u00E1gina no Encontrada" })), (0, jsx_runtime_1.jsx)(ButtomComponent_1.default, __assign({ variant: "contained", onClick: redirectToHome }, { children: "Regresar al Inicio" }))] })) }));
};
exports.default = NotFound;
